import React from 'react'
import { Link } from 'react-router'
import Container from 'muicss/lib/react/container'
import Button from 'muicss/lib/react/button'
import IcoMail from 'react-icons/lib/io/paper-airplane'

import ListHeaderNav from './ListHeaderNav'
import ItemList from './ItemList.jsx'

const MyList = ({ mailto, items, images }) => (
  <div>
    <div className="list-header --water">
      <Container>
        <ListHeaderNav />
        <div className="list-header__content">
          <h1 className="list-header__title">マイリスト</h1>
          <a href={mailto}>
            <Button size="large" color="primary" className="list-header__action">
              <IcoMail />リストを元にメール問合せ
            </Button>
          </a>
        </div>
      </Container>
    </div>
    <ItemList items="" images={images} />
  </div>
)

export default MyList



// WEBPACK FOOTER //
// ./src/components/MyList.js